/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Risk_High_OverloadInputs */

const en_coach_risk_high_overload = /** @type {(inputs: Coach_Risk_High_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are deeply fatigued with a dangerous load spike. This is the highest-risk state — injury likelihood is significantly elevated. Rest immediately and do not resume hard training until fatigue subsides.`)
};

const de_coach_risk_high_overload = /** @type {(inputs: Coach_Risk_High_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stark ermüdet mit gefährlichem Belastungsanstieg. Das ist der riskanteste Zustand — Verletzungsgefahr deutlich erhöht. Ruh dich sofort aus und trainiere erst wieder hart, wenn die Ermüdung nachlässt.`)
};

/**
* | output |
* | --- |
* | "You are deeply fatigued with a dangerous load spike. This is the highest-risk state — injury likelihood is significantly elevated. Rest immediately and do no..." |
*
* @param {Coach_Risk_High_OverloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_risk_high_overload = /** @type {((inputs?: Coach_Risk_High_OverloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Risk_High_OverloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_risk_high_overload(inputs)
	return de_coach_risk_high_overload(inputs)
});